import { GameVars } from "../../../GameVars";
import { Button } from "../../../utils/Button";
import { GameManager } from "../../../managers/GameManager";
import { GameConstants } from "../../../GameConstants";
import { HiLoManager } from "../../../managers/HiLoManager";
import { AudioManager } from "../../../managers/AudioManager";
import { HiLoButtonsContainer } from "./HiLoButtonsContainer";

export class HiLoGUI extends Phaser.GameObjects.Container {

    private audioButton: Button;
    private infoButton: Button;
    private resetButton: Button;

    private hiLoButtonsContainer: HiLoButtonsContainer;
    private menuButton: Button;
    private backButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.menuButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_menu.png", "btn_menu.png", true, true);
        this.menuButton.scaleX = GameVars.scaleX;
        this.menuButton.onUp(this.onClickBack, this);
        this.add(this.menuButton); 

        this.backButton = new Button(this.scene, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_close.png", "btn_close.png", true, true, .82);
        this.backButton.scaleX = GameVars.scaleX * .82;
        this.backButton.onUp(this.onClickBack, this);
        this.backButton.visible = false;
        this.add(this.backButton); 

        let audioButtonFrameName = GameVars.gameData.muted ? "btn_sound_off.png" : "btn_sound_on.png";

        this.audioButton = new Button(this.scene, GameConstants.GAME_WIDTH - 35 * GameVars.scaleX, 35, "texture_atlas_1", audioButtonFrameName, audioButtonFrameName, true, true);
        this.audioButton.scaleX = GameVars.scaleX;
        this.audioButton.onUp(this.onClickAudio, this);
        this.add(this.audioButton); 

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            this.menuButton.x = this.audioButton.x - (this.audioButton.width + 10) * GameVars.scaleX;
            this.backButton.x = this.menuButton.x;
        }

        this.hiLoButtonsContainer = new HiLoButtonsContainer(this.scene);
        this.add(this.hiLoButtonsContainer);

        this.infoButton = new Button(this.scene, GameConstants.GAME_WIDTH - 45 * GameVars.scaleX,  GameConstants.GAME_HEIGHT - 45, "texture_atlas_1", "btn_info_high_low.png", "btn_info_high_low.png", true, true);
        this.infoButton.scaleX = GameVars.scaleX;
        this.infoButton.onUp(this.onClickInfo, this);
        this.add(this.infoButton);

        this.resetButton = new Button(this.scene, 35 * GameVars.scaleX,  GameConstants.GAME_HEIGHT - 35, "texture_atlas_1", "btn_reset.png", "btn_reset.png", true, true);
        this.resetButton.scaleX = GameVars.scaleX;
        this.resetButton.onUp(this.onClickReset, this);
        this.add(this.resetButton); 
    }

    public onGameOver(): void {

        this.hiLoButtonsContainer.onGameOver();
        this.hideOnComplete();
    }

    public onGameCompleted(): void {

        this.hiLoButtonsContainer.onGameCompleted();
        this.hideOnComplete();
    }

    public hideOnComplete(): void {

        this.backButton.visible = true;
        this.menuButton.visible = false;
        this.resetButton.visible = false;

        this.scene.tweens.add({
            targets: this.hiLoButtonsContainer,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            delay: 500
        });
    }

    public onReplay(): void {

        this.hiLoButtonsContainer.alpha = 1;
        this.hiLoButtonsContainer.onReplay();

        this.backButton.visible = false;
        this.menuButton.visible = true;
        this.resetButton.visible = true;
    }

    public onInfoLayerHidden(): void {

        this.infoButton.visible = true;
    }

    private onClickInfo(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.playSound("btn_click");

        this.infoButton.visible = false;

        HiLoManager.showInfoLayer();
    }

    private onClickBack(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.playSound("btn_click");

        GameManager.enterSplashScene();
    }

    private onClickReset(): void {

        if (GameVars.paused) {
            return;
        }

        HiLoManager.onReplay();
    }

    private onClickAudio(): void {

        if (GameVars.paused) {
            return;
        }

        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioButton.frameNameOff = "btn_sound_off.png";
            this.audioButton.frameNameOn =  "btn_sound_off.png";
        } else {
            this.audioButton.frameNameOff = "btn_sound_on.png";
            this.audioButton.frameNameOn =  "btn_sound_on.png";
        }

        AudioManager.playSound("btn_click");
    }
}
